module.exports = __webpack_public_path__ + "images/1ea55a8f.png";